export default __webpack_public_path__ + "static/media/banner-delete.5440e6f8.svg";